import { observable, action, runInAction } from "mobx";
// import * as TenantInfoAPI from "../../../api/tenantInfo";
import { createTenantParamsType } from "../createTeam/type";
import * as API from '../../../../api/m/teams'
import { Dialog } from "@weapp/ui";
// import * as LoginAPI from "../../../api/login";
// import { loginParamsType } from "../../m/login/type";
// import { setCookie, mainHost } from "../../../utils";
import { MDialog } from '@weapp/ui';
import { layoutPublicUrl, publicUrlapi } from "../../../../constants";
import { isIntunifyauthLogin } from "../../../../utils";
const { toast } = MDialog;
const { message } = Dialog;
export class mCreateTeamStore {
    @observable createLimit = false;
    @action
    createTenant = (data: any) => {
        console.log(data, "meichufama1")
        API.createTeams(data)
            .then((result: any) => {
                runInAction(() => {
                    if (result.newEmpId) {
                        const origin = `${window.location?.protocol}//${window.location?.host}`;
                        window.location.href = (window.weappTenantEnv?.passportUrl || window.TEAMS?.passportUrl) +
                          publicUrlapi + '/papi/passport/changeTenantNew/' +
                          result.newEmpId +
                          `?ETEAMSID=${window.ETEAMSID}&service=${encodeURIComponent(origin + layoutPublicUrl)}`
                    } else {
                        // callback && callback()
                        toast({
                            content: result.message,
                        });
                    }
                });
            })
            .catch((error) => {
                // callback && callback()
                console.log(error);
            });

        // if (!this.createLimit) {
        //     this.createLimit = true;
        //     TenantInfoAPI.createTenant(obj).then((result: any) => {
        //         runInAction(() => {
        //             if (result.message) {
        //                 message({
        //                     type: "error",
        //                     content: result.message,
        //                 });
        //                 this.createLimit = false;
        //             } else {
        //                 //TODO 登录并跳转
        //                 const accoutObj = {
        //                     username: window.sessionStorage.getItem('passport_sign_account') as string,
        //                     password: window.sessionStorage.getItem('passport_sign_psw') as string
        //                 }
        //                 LoginAPI.login(accoutObj).then((result: any) => {
        //                     if ("true" == result.succeed && (result.ETEAMSID != null && result.ETEAMSID != "")) {
        //                         let host = window.location.hostname;
        //                         let domain = host.substr(host.indexOf(".") + 1);
        //                         setCookie('ETEAMSID', result.ETEAMSID, domain);
        //                         window.location.href = mainHost();
        //                     } else {
        //                         toast({
        //                             type: 'fail', // type: 'info', 'fail', 'success'
        //                             content: result.message
        //                         });

        //                     }
        //                 });
        //                 this.createLimit = false;
        //             }
        //         });
        //     }).catch((error: any) => {
        //         console.log(error);
        //         this.createLimit = false;
        //     });
        // }
    };
}

const instance = new mCreateTeamStore();

export default instance;
